import type { FallbackProps } from 'react-error-boundary'

/**
 * Last-resort fallback for errors that escape every route boundary. It can
 * render before i18n is ready (e.g. if translations themselves fail to
 * load), so the copy is intentionally not translated.
 */
export function AppErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-fg text-2xl font-bold">Something went wrong</h1>
      <p className="text-fg-muted max-w-md">
        {error instanceof Error ? error.message : 'Unexpected application error'}
      </p>
      <button
        type="button"
        onClick={resetErrorBoundary}
        className="bg-brand-600 hover:bg-brand-700 rounded-lg px-4 py-2 text-sm font-medium text-white transition"
      >
        Try again
      </button>
    </div>
  )
}
